const PROBLEMS = [
  "すべての候補者に同じメッセージを送っている",
  "スカウト業務に関する担当者の負担が大きすぎる",
  "誰にどんなスカウトを送ったか、ブラックボックスになっている",
  "分析も改善もできていない",
];

export function ProblemSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-start gap-14 px-6 py-24 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
        <div>
          <h2 className="text-[36px] font-bold leading-[1.25] tracking-tight md:text-[44px]">
            <span className="whitespace-nowrap">スカウト業務の見える化</span>
            <br />
            <span className="whitespace-nowrap">できていますか？</span>
          </h2>
          <ul className="mt-10 divide-y divide-dashed divide-ink-200">
            {PROBLEMS.map((problem) => (
              <li className="flex items-start gap-3 py-4" key={problem}>
                <span className="mt-0.5 grid h-6 w-6 place-items-center rounded-full bg-rose-50 text-rose-500">
                  <span className="mi text-[16px]">close</span>
                </span>
                <span className="text-[15px] text-ink-700">{problem}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="relative">
          <img
            alt="散在する業務ツールに困る人物"
            className="w-full rounded-2xl bg-white"
            src="/images/lp/problem.png"
          />
        </div>
      </div>
    </section>
  );
}
